import React from 'react';
import { useAppStateContext } from 'src/AppState/AppState';
import { TabsWrapperLang } from 'src/components/TranslationsContent/SelectedLanguage/TranslationFilter/TranslationFilter.style';
import { Tab } from 'src/components/Tab/Tab.style';
import { observer } from 'src/utils/mobx-react';

export const TranslationFilter = observer('TranslationFilter', (): JSX.Element => {
    const { translationPageState } = useAppStateContext();
    const { selectStaticTranslation, selectFeedTranslation, selectedPageType } = translationPageState;

    return (
        <TabsWrapperLang>
            <Tab isActive={selectedPageType === 'static-translation'} onClick={selectStaticTranslation}>
                Static Keys
            </Tab>

            <Tab isActive={selectedPageType === 'feed-translation'} onClick={selectFeedTranslation}>
                Dynamic Feed
            </Tab>
        </TabsWrapperLang>
    );
});
